import { RootState } from "../store";
import { UserProfile, UserRole } from "./types";

export const selectUserProfile = (state: RootState): UserProfile =>
  state.auth.userProfile;
export const selectUserRole = (state: RootState): UserRole =>
  state.auth.userRole;
export const selectUserAvatar = (state: RootState): string =>
  state.auth.userAvatar;
